import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// SECTION: AUTH THUNKS

// NOTE: User Signin
export const signin = createAsyncThunk("user/login", async (data) => {
  const response = await api.post("user/login", data);
  return response.data;
});

// NOTE: User Signup
export const signup = createAsyncThunk("auth/signup/user", async (data) => {
  const response = await api.post("auth/signup", data);
  return response.data;
});

export const requestOTP = createAsyncThunk("user/request-otp", async (data) => {
  const response = await api.post("user/forgot-password", {
    contact: data.emailOrPhone,
  });
  return response.data;
});

export const verifyOTP = createAsyncThunk(
  "user/verify-otp",
  async ({ contact, otp }) => {
    const response = await api.post("user/verify-otp", {
      contact,
      otp,
    });
    return response.data;
  }
);

export const resetUserPassword = createAsyncThunk(
  "user/reset-password",
  async ({ contact, otp, newPassword }, { rejectWithValue }) => {
    const response = await api.post("user/reset-password", {
      contact,
      otp,
      newPassword,
    });
    return response.data;
  }
);

// NOTE: Tasker Signup
export const taskerSignup = createAsyncThunk(
  "auth/signup/tasker",
  async (data) => {
    const response = await api.post("user/signup/tasker", data);
    return response.data;
  }
);

// NOTE: Authenticated link for resetting password
export const resetPassword = createAsyncThunk(
  "auth/reset/password",
  async (data) => {
    const response = await api.post("auth/forgot-password", data);
    return response.data;
  }
);

// NOTE: Validating the generated authenticaion token for password reset
export const validateToken = createAsyncThunk(
  "auth/validate/token",
  async ({ id, token }) => {
    const response = await api.get(`auth/verify-forgot/${id}/${token}`);
    return response.data;
  }
);

// NOTE: Resetting the password
export const updatePassword = createAsyncThunk(
  "auth/update/password",
  async ({ id, data }) => {
    const response = await api.put(`user/change-password/${id}`, data);
    return response.data;
  }
);

// NOTE: Update User Profile
export const updateUserProfile = createAsyncThunk(
  "user/update/profile",
  async (data) => {
    const response = await api.put("user/edit-user", data);
    return response.data;
  }
);
